module.exports = __webpack_public_path__ + "static/media/aaop_logo_new.14ac6a12.svg";